export interface UiOption<T = string> {
  label: string;
  value: T;
}

export const YES_NO_OPTIONS: UiOption<string>[] = [
  { label: 'Nej', value: 'N' },
  { label: 'Ja', value: 'J' },
];

export const EMPLOYEE_ACTIVE_FILTER_OPTIONS: UiOption<'all' | 'active' | 'inactive'>[] = [
  { label: 'Alla', value: 'all' },
  { label: 'Aktiva', value: 'active' },
  { label: 'Ej aktiva', value: 'inactive' },
];

export const EMPLOYEE_TYPE_FILTER_OPTIONS: UiOption<'all' | 'kitsare' | 'uk'>[] = [
  { label: 'Alla', value: 'all' },
  { label: 'Kitsare', value: 'kitsare' },
  { label: 'UK', value: 'uk' },
];

export const ALL_EMPLOYEES_OPTION = {
  employee_id: 0,
  name: 'Alla anställda',
} as const;
